module.exports = __webpack_public_path__ + "static/mountain-video-7ca2d03e33f1460a65979ad90e54de82.png";